import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from 'src/components/system/Button';
import { Page, Card, Title, Input, ErrorText } from './styles';
import { register } from 'src/services/auth';
import { sendLeadToRDStation } from 'src/services/rdstation';

export function Register() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [password_confirmation, setPasswordConfirmation] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (password !== password_confirmation) {
      setError('As senhas não conferem.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await register({ name, email, phone, password, password_confirmation });
      
      // Envia o lead para o RD Station assincronamente (sem aguardar para não travar a UI)
      sendLeadToRDStation(email, name).catch(console.error);

      // após criar a conta, redireciona para login
      navigate('/auth/login');
    } catch (err: any) {
      setError('Falha no cadastro.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Page>
      <Card>
        <Title>Criar conta</Title>
        <form onSubmit={onSubmit}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <Input placeholder="Nome completo" value={name} onChange={e => setName(e.target.value)} required />
            <Input placeholder="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
            <Input
              placeholder="Celular"
              type="tel"
              autoComplete="tel"
              value={phone}
              onChange={e => setPhone(e.target.value)}
              required
            />
            <Input placeholder="Senha" type="password" value={password} onChange={e => setPassword(e.target.value)} required />
            <Input placeholder="Confirmar senha" type="password" value={password_confirmation} onChange={e => setPasswordConfirmation(e.target.value)} required />
            {error && <ErrorText>{error}</ErrorText>}
            <Button
              width="100%"
              backgroundColor="#222B82"
              borderColor="#222B82"
              buttonColor="#fff"
              type="submit"
              disabled={loading}
              label={<span>{loading ? 'Enviando...' : 'Criar conta'}</span>}
            />
          </div>
        </form>
        <Link to="/auth/login">Já tenho conta</Link>
      </Card>
    </Page>
  );
}
